module.exports = __webpack_public_path__ + "static/logo-mobile-ad5a9079f0c21619a0717433f967e86e.svg";